<section class="page-hero products-hero-pro">
    <div class="products-hero-bg"></div>

    <div class="container">
        <div class="products-hero-content">
            <span class="eyebrow"><i></i> Product Catalog</span>

            <h1>Industrial products prepared for RFQ workflow.</h1>

            <p>
                Browse IOSC product categories, search items and send your requirements
                to the team for quotation.
            </p>
        </div>
    </div>
</section>

<section class="section products-section-pro">
    <div class="container product-shell">

        <aside class="side-panel products-side-panel reveal">
            <input class="search"
                   placeholder="Search product, category or item code..."
                   name="searchText"
                   [(ngModel)]="searchText"
                   (input)="applyFilter()">

            <div class="cat-list">
                <button type="button"
                        class="cat-btn"
                        *ngFor="let cat of categories"
                        [class.active]="selectedCategory === cat"
                        (click)="selectCategory(cat)">
                    {{ cat }}
                </button>
            </div>
        </aside>

        <main id="productListTop">
            <div class="section-head reveal" style="margin-bottom:22px">
                <div>
                    <span class="section-kicker">Catalog Preview</span>
                    <h2>Products by industrial category.</h2>
                </div>

                <p>
                    Browse industrial products and send your requirements to IOSC for quotation.
                </p>
            </div>

            <div *ngIf="loading" style="padding:20px 0">
                Loading products...
            </div>

            <div *ngIf="errorMessage" class="alert error">
                {{ errorMessage }}
            </div>

            <div class="product-grid" *ngIf="!loading && !errorMessage">
                <article class="prod-card product-card-pro reveal"
                         *ngFor="let p of filteredProducts">

                    <div class="prod-img product-image-box">
                        <img [src]="p.img || 'assets/img/products/no-image.png'"
                             [alt]="p.name"
                             loading="lazy"
                             (error)="onImageError($event)">
                    </div>

                    <div class="prod-body">
                        <button type="button"
                                class="tag product-tag-btn"
                                (click)="selectCategory(p.groupName, true)">
                            {{ p.groupName }}
                        </button>

                        <h3>{{ p.name }}</h3>

                        <p>
                            Item Code: {{ p.id }}
                        </p>
                    </div>

                </article>
            </div>

            <div *ngIf="!loading && !errorMessage && filteredProducts.length === 0"
                 style="padding:20px 0">
                No products found.
            </div>

        </main>

    </div>
</section>

<section class="section dark-band products-rfq-band">
    <div class="container split">
        <div class="reveal">
            <span class="section-kicker">RFQ Ready</span>

            <h2>Turn catalog browsing into quote requests.</h2>

            <p style="color:#c9d9ea">
                Customers can review product categories, identify item codes and send
                requirements to IOSC for quotation support.
            </p>

            <a class="btn btn-primary" routerLink="/contact">
                Request Quote
            </a>
        </div>

        <div class="quote-panel reveal">
            <h3 style="color:var(--ink);margin-top:0">
                Catalog Workflow
            </h3>

            <div class="feature-list">
                <div class="feature">
                    <span class="check">✓</span>
                    <div>
                        <b>Live product list</b><br>
                        <span>Products are loaded directly from the API.</span>
                    </div>
                </div>

                <div class="feature">
                    <span class="check">✓</span>
                    <div>
                        <b>Category filter</b><br>
                        <span>Users can filter products by industrial group.</span>
                    </div>
                </div>

                <div class="feature">
                    <span class="check">✓</span>
                    <div>
                        <b>Search support</b><br>
                        <span>Search works by product name, category and item code.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>